import VueRouter from "vue-router";

import login from "../views/login.vue";

const router = new VueRouter({
  mode: "history",
  // mode:"hash",
  routes: [
    {
      path: "/personalInfor",
      component: () => import("@/components/personalInfor"),
    },
    {
      path: "/forget",
      component: () => import("@/components/forget"),
    },
    {
      path: "/mobileForm",
      component: () => import("@/views/mobileForm"),
    },
    {
      path: "/setPwd",
      component: () => import("@/components/setPwd"),
    },
    {
      path: "/",
      component: () => import("@/views/index"),
    },
    {
      path: "/login",
      component: () => import("@/views/login"),
    },
    {
      path: "/securityScreen1",
      component: () => import("@/views/securityScreen/index1"),
    },
    {
      path: "/securityScreen2",
      component: () => import("@/views/securityScreen/index2"),
    },
    {
      path: "/securityScreen3",
      component: () => import("@/views/securityScreen/index3"),
    },
    {
      path: "/cas/hello",
      component: () => import("@/views/login"),
    },
    {
      path: "/look",
      component: () => import("@/views/look"),
    },
    {
      path: "/jwy",
      name: "级",
      component: () => import("@/views/jwy"),
    },
    {
      path: "/personal",
      component: () => import("@/views/personal"),
    },
    {
      path: "/logins",
      component: () => import("@/views/logins"),
    },

    {
      path: "/index",
      component: () => import("@/views/index"),
      children: [
        {
          // 控制台
          path: "console",
          component: () => import("@/views/console/console"),
          children: [
            // {
            // 	path: "",
            // 	name: "预入住登记",
            // 	component: () => import("@/views/console/register")
            // },
            {
              path: "/",
              // component: () => import("@/views/console/statistics")
              component: () => import("@/views/console/register"),
            },
            {
              path: "register",
              name: "预约入住登记",
              component: () => import("@/views/console/register"),
            },
            {
              path: "statistics",
              name: "预约入住统计",
              component: () => import("@/views/console/statistics"),
            },
            {
              path: "announceAndNotice",
              name: "公告和通知",
              component: () => import("@/views/console/announceAndNotice"),
            },
          ],
        },
        {
          path: "/index/controller",
          name: "工作台",
          component: () => import("@/views/controller/controller"),
          children: [
            {
              path: "",
              name: "工作台",
              component: () => import("@/views/controller/controllerYm"),
            },
            {
              path: "/index/controllerYm",
              name: "工作台",
              component: () => import("@/views/controller/controllerYm"),
            },
          ],
        },
         // 客流
         {
          path: "securityScreen2",
          component: () => import("@/views/securityScreen/index4"),
        },
        {
          // 公寓
          path: "apartment",
          component: () => import("@/views/apartment/apartment"),
          children: [
            {
              path: "personnelInformation",
              name: "人才信息",
              component: () => import("@/views/apartment/personnelInformation"),
            },
            {
              path: "scheduleMan",
              name: "进度管理",
              component: () => import("@/views/apartment/scheduleMan"),
            },
            {
              path: "evaluationRecord",
              name: "评价记录",
              component: () => import("@/views/apartment/evaluationRecord"),
            },
            {
              path: "jiazhen",
              name: "家政服务",
              component: () => import("@/views/apartment/jiazhen"),
            },
            {
              path: "swhk",
              name: "商务会客",
              component: () => import("@/views/apartment/swhk"),
            },
            {
              path: "fwxm",
              name: "服务项目",
              component: () => import("@/views/apartment/fwxm"),
            },
            {
              path: "xiyi",
              name: "洗衣服务",
              component: () => import("@/views/apartment/xiyi"),
            },
            {
              path: "advice",
              name: "投诉与建议",
              component: () => import("@/views/apartment/advice"),
            },
            {
              path: "fwrx",
              name: "服务热线",
              component: () => import("@/views/apartment/fwrx"),
            },
            {
              path: "visitorsRecord",
              name: "访客记录",
              component: () => import("@/views/apartment/visitorsRecord"),
            },
            {
              path: "FaultMem",
              name: "故障类型管理",
              component: () => import("@/views/apartment/FaultMem"),
            },
            {
              path: "personnelInformation/applyCheckIn",
              name: "入住申请",
              component: () =>
                import("@/views/apartment/component/applyCheckIn"),
            },
            {
              path: "customerInformation",
              name: "客房信息",
              component: () => import("@/views/apartment/customerInformation"),
            },
            {
              path: "customerInformation/customerRoom",
              name: "房态图",
              component: () => import("@/views/apartment/customerRoom"),
            },
            // 点击客房管理房态图进入详情
            {
              path: "customerInformation/checkCustomerRoom",
              name: "房态图详情",
              component: () =>
                import("@/views/apartment/component/customerRoomDetail"),
            },
            {
              path: "ownerManagement",
              name: "业主信息",
              component: () => import("@/views/apartment/ownerManagement"),
            },
            {
              path: "constractInformation",
              name: "合同信息",
              component: () => import("@/views/apartment/constractInformation"),
            },
            {
              path: "repair",
              name: "报修管理",
              component: () => import("@/views/apartment/repair"),
            },
            {
              path: "occupancyApplication",
              name: "入住",
              component: () => import("@/views/apartment/occupancyApplication"),
            },
            {
              path: "checkIn",
              name: "入住登记",
              component: () => import("@/views/apartment/checkIn"),
            },
            {
              path: "exitIn",
              name: "退房登记",
              component: () => import("@/views/apartment/exitIn"),
            },
          ],
        },
        {
          // 成员
          path: "/index/member",
          name: "成员",
          component: () => import("@/views/member/member"),
          children: [
            {
              path: "/index/member/personnelInformation/:id",
              name: "人才信息",
              component: () => import("@/views/apartment/personnelInformation"),
            },
            {
              path: "/index/member/administrator/:name/:id",
              name: "管理员",
              component: () => import("@/views/member/administrator"),
            },
            {
              path: "/",
              // component: () => import("@/views/member/administratorProperty"),
            },
            {
              path: "/index/member/administratorProperty",
              name: "物业管理部门",
              component: () => import("@/views/member/administratorProperty"),
            },
            {
              path: "/index/member/administratorFlats",
              name: "公寓管理部门",
              component: () => import("@/views/member/administratorFlats"),
            },
            {
              path: "/index/member/dutyManager",
              name: "值班经理",
              component: () => import("@/views/member/dutyManager"),
            },
            {
              path: "/index/member/administrator",
              name: "商管理部",
              component: () => import("@/views/member/administrator"),
            },

            {
              path: "/index/member/ownerManagement",
              name: "业主",
              component: () => import("@/views/member/ownerManagement"),
            },
            {
              path: "/index/member/merchant",
              name: "商户",
              component: () => import("@/views/member/merchant"),
            },
            {
              path: "/index/member/servicePersonal",
              name: "第三方服务人员",
              component: () => import("@/views/member/servicePersonal"),
            },
            // {
            // 	path: "/index/member/storeInformation",
            // 	component: () => import("@/views/member/storeInformation")
            // },
            // {
            // 	path: "/index/member/storeDetail",
            // 	name:'商铺详情',
            // 	component: () => import("@/views/member/storeDetail")
            // }
          ],
        },
        {
          // 消息
          path: "/index/message",
          name: "消息",
          component: () => import("@/views/message/message"),
          children: [
            {
              path: "/",
              name: "公告管理",
              component: () => import("@/views/message/announceInfor"),
            },
            {
              path: "/index/message/notice",
              name: "消息管理通知",
              component: () => import("@/views/message/notice"),
            },
            {
              path: "noticeDetail",
              name: "发送消息",
              component: () =>
                import("@/views/message/components/noticeDetail"),
            },
            {
              path: "forgetPasswordCheck",
              name: "忘记密码审核",
              component: () => import("@/views/message/forgetPasswordCheck"),
            },
            {
              path: "announceInfor",
              name: "公告通知管理",
              component: () => import("@/views/message/announceInfor"),
            },
            {
              path: "announce",
              name: "发布公告",
              component: () => import("@/views/message/announce"),
            },
            {
              path: "rzsm",
              name: "入住说明",
              component: () => import("@/views/message/rzsm"),
            },
            {
              path: "rzsmInfo",
              name: "入住说明详情",
              component: () => import("@/views/message/rzsmInfo"),
            },
          ],
        },

        {
          // 任务管理
          path: "/index/task",
          name: "任务",
          component: () => import("@/views/task/task"),
          children: [
            {
              path: "/",
              name: "流程",
              component: () => import("@/views/task/process"),
            },
            {
              path: "/index/task/process",
              name: "我的流程",
              component: () => import("@/views/task/process"),
            },
            {
              path: "/index/task/todo",
              name: "待办任务",
              component: () => import("@/views/task/todo"),
            },
            {
              path: "/index/task/finished",
              name: "已办任务",
              component: () => import("@/views/task/finished"),
            },
            {
              path: "/index/task/index",
              name: "流程处理",
              component: () => import("@/views/task/index"),
            },
            {
              path: "/index/task/todoGroup",
              name: "代办组任务",
              component: () => import("@/views/task/todoGroup"),
            },
          ],
        },
        {
          // 对账
          path: "/index/recon",
          name: "任务",
          component: () => import("@/views/recon/recon"),
          children: [
            {
              path: "/index/recon/wydz",
              name: "物业对账",
              component: () => import("@/views/recon/wydz"),
            },
            {
              path: "/index/recon/sgdz",
              name: "商管对账",
              component: () => import("@/views/recon/sgdz"),
            },
            {
              path: "/index/recon/xtdzDetail",
              name: "对账详情",
              component: () => import("@/views/recon/xtdzDetail"),
            },
          ],
        },
        {
          path: "/index/system",
          component: () => import("@/views/system/system"),
          children: [
            {
              path: "role",
              component: () => import("@/views/system/role"),
            },
            {
              path: "log",
              component: () => import("@/views/system/log"),
            },
            {
              path: "jobs",
              component: () => import("@/views/system/jobs"),
            },
            {
              path: "department",
              component: () => import("@/views/system/department"),
            },
            {
              path: "games",
              component: () => import("@/views/system/games"),
            },
          ],
        },
        {
          //访客
          path: "/index/visitor",
          component: () => import("@/views/visitor/visitor"),
          children: [
            {
              path: "/",
              component: () => import("@/views/visitor/visitRecord"),
            },
            {
              path: "/index/visitor/visitRecord",
              component: () => import("@/views/visitor/visitRecord"),
            },
          ],
        },
        {
          //数据大屏
          path: "/index/bigDataScreen",
          component: () => import("@/views/bigDataScreen/bigDataScreen"),
          children: [
            {
              path: "/",
              component: () => import("@/views/bigDataScreen/bigData"),
            },
            {
              path: "/index/bigDataScreen/bigData",
              component: () => import("@/views/bigDataScreen/bigData"),
            },
            {
              path: "/index/bigDataScreen/bigData2",
              component: () => import("@/views/bigDataScreen/bigData2"),
            },
            {
              path: "/index/bigDataScreen/energyData",
              name: "能耗数据",
              component: () =>
                import("@/views/engineering/energyManage/energyData"),
            },
           
          ],
        },
        {
          //商业
          path: "/index/business",
          component: () => import("@/views/business/business"),
          children: [
            // {
            //   path: "/",
            //   component: () => import("@/views/business/businessPlanning"),
            // },
            {
              path: "/index/business/businessPlanning",
              component: () => import("@/views/business/businessPlanning"),
            },
            {
              path: "/index/business/ofShops",
              component: () => import("@/views/business/ofShops"),
            },
            {
              path: "/index/business/investmentManagement",
              component: () => import("@/views/business/investmentManagement"),
            },
            {
              path: "/index/business/investmentPromotionContract",
              component: () =>
                import("@/views/business/investmentPromotionContract"),
            },           
            {
              path: "/index/business/storeInformation",
              name:"商铺信息",
              component: () => import("@/views/business/storeInformation"),
            },
            {
              path: "/index/business/storeStatus",
              name:"空铺统计",
              component: () => import("@/views/business/storeStatus"),
            },
            {
              path: "/index/business/storeInformation2",
              name:"租金减免",
              component: () => import("@/views/business/storeInformation2"),
            },
            {
              path: "/index/business/newPromotion2",
              name: "提成租金",
              component: () => import("@/views/business/newPromotion2"),
            },
            {
              path: "/index/business/decorateToApplyFor",
              component: () => import("@/views/business/decorateToApplyFor"),
            },
            {
              path: "/index/business/storeDetail",
              name: "商铺详情",
              component: () => import("@/views/business/storeDetail"),
            },
            {
              path: "/index/business/feeCollection",
              name: "费用收缴",
              component: () => import("@/views/business/feeCollection"),
            },
            {
              path: "/index/business/newPromotion",
              name: "招商合同",
              component: () => import("@/views/business/newPromotion"),
            },
            {
              path: "/index/business/newPromotionOther",
              name: "其他合同",
              component: () => import("@/views/business/newPromotionOther"),
            },
            {
              path: "/index/business/contractBill",
              name: "合同账单",
              component: () => import("@/views/business/contractBill"),
            },
            {
              path: "/index/business/xtdz",
              name: "系统对账",
              component: () => import("@/views/business/xtdz"),
            },
            {
              path: "/index/business/xtdzDetail",
              name: "系统对账详情",
              component: () => import("@/views/business/xtdzDetail"),
            },
          ],
        },
        {
          //审批流程
          path: "/index/sp",
          component: () => import("@/views/sp/sp"),
          children: [
            {
              path: "/index/sp/htsp",
              component: () => import("@/views/sp/wsp"),
            },
            {
              path: "/index/sp/ysp",
              component: () => import("@/views/sp/ysp"),
            },
          ],
        },
        {
          //安防
          path: "/index/security",
          component: () => import("@/views/security/security"),
          children: [
            // {
            //   path: "/",
            //   component: () => import("@/views/security/inspectionSchedule"),
            // },
            {
              path: "/index/security/inspectionSchedule",
              component: () => import("@/views/security/inspectionSchedule"),
            },
            {
              path: "/index/security/inspectionResults",
              component: () => import("@/views/security/inspectionResults"),
            },
            {
              path: "/index/security/regionalManagement",
              component: () => import("@/views/security/regionalManagement"),
            },
            {
              path: "/index/security/abnormal",
              component: () => import("@/views/security/abnormal"),
            },
            //排班计划
            {
              path: "/index/security/rosteringPlan",
              component: () => import("@/views/security/rosteringPlan"),
            },
            //巡检管理
            {
              path: "/index/security/Inspection",
              component: () => import("@/views/security/Inspection"),
            },
            //值岗管理
            {
              path: "/index/security/onDuty",
              component: () => import("@/views/security/onDuty"),
            },
            //三关一闭
            {
              path: "/index/security/threePassesOneClose",
              component: () => import("@/views/security/threePassesOneClose"),
            },
            {
              path: "/index/security/realTimeVideo",
              component: () => import("@/views/security/realTimeVideo"),
            },
            {
              path: "/index/security/safetyLevel",
              component: () => import("@/views/security/safetyLevel"),
            },
            {
              path: "/index/security/securityIncidents",
              component: () => import("@/views/security/securityIncidents"),
            },
            {
              path: "/index/security/grsc",
              component: () => import("@/views/security/grsc"),
            },
            {
              path: "/index/security/kqjl",
              component: () => import("@/views/security/kqjl"),
            },
            {
              path: "/index/security/kqjhb",
              component: () => import("@/views/security/kqjhb"),
            },
            {
              path: "/index/security/xjjl",
              component: () => import("@/views/security/xjjl"),
            },
            {
              path: "/index/security/xjdk",
              component: () => import("@/views/security/xjdk"),
            },
            ,
            {
              path: "/index/security/passengerFlowAnalysis",
              name: "客流分析",
              component: () => import("@/views/security/passengerFlowAnalysis"),
            }
          ],
        },
        {
          //对账
          path: "/index/reconciliation",
          component: () => import("@/views/reconciliation/index"),
          children: [
            {
              path: "/index/reconciliation/collection",
              name: "费用收缴",
              component: () =>
                import("@/views/reconciliation/shopReconciliation/collection"),
            },
            {
              path: "/index/reconciliation/contractBill",
              name: "应缴费用",
              component: () => import("@/views/reconciliation/shopReconciliation/contractBill"),
            },
            {
              path: "/index/reconciliation/contractBill2",
              name: "催缴通知",
              component: () => import("@/views/reconciliation/shopReconciliation/contractBill2"),
            },
            {
              path: "/index/reconciliation/bankStatement",
              name: "实缴费用",
              component: () =>
                import(
                  "@/views/reconciliation/shopReconciliation/bankStatement"
                ),
            },
            {
              path: "/index/reconciliation/systemReconciliation",
              name: "系统对账",
              component: () =>
                import(
                  "@/views/reconciliation/shopReconciliation/systemReconciliation"
                ),
            },
            {
              path: "/index/reconciliation/systemReconciliation2",
              name: "开票信息",
              component: () =>
                import(
                  "@/views/reconciliation/shopReconciliation/systemReconciliation2"
                ),
            },
            {
              path: "/index/reconciliation/billingReport",
              name: "年度月份账单",
              component: () =>
                import(
                  "@/views/reconciliation/shopReconciliation/billingReport"
                ),
            },
            {
              path: "/index/reconciliation/infoMaintain",
              name: "信息维护",
              component: () =>
                import(
                  "@/views/reconciliation/shopReconciliation/infoMaintain"
                ),
            },
            {
              path: "/index/reconciliation/viewAll",
              name: "查询统计",
              component: () =>
                import(
                  "@/views/reconciliation/shopReconciliation/viewAll"
                ),
            },
            {
              path: "/index/reconciliation/reportForm/propertyFee",
              name: "物业对账",
              component: () =>
                import("@/views/reconciliation/reportForm/propertyFee"),
            },
            {
              path: "/index/reconciliation/propertyFeeReport",
              name: "物业费报表",
              component: () =>
                import("@/views/reconciliation/reportForm/propertyFeeReport"),
            },
            {
              path: "/index/reconciliation/paidFeeReport",
              name: "有偿收费报表",
              component: () =>
                import("@/views/reconciliation/reportForm/paidFeeReport"),
            },
            {
              path: "/index/reconciliation/publicPowerRateReport",
              name: "公摊电费报表",
              component: () =>
                import(
                  "@/views/reconciliation/reportForm/publicPowerRateReport"
                ),
            },
            {
              path: "/index/reconciliation/indoorPowerRateReport",
              name: "户内电费报表",
              component: () =>
                import(
                  "@/views/reconciliation/reportForm/indoorPowerRateReport"
                ),
            },
            {
              path: "/index/reconciliation/waterRateReport",
              name: "水费报表",
              component: () =>
                import("@/views/reconciliation/reportForm/waterRateReport"),
            },
            {
              path: "/index/reconciliation/publicWaterReport",
              name: "公摊水费报表",
              component: () =>
                import("@/views/reconciliation/reportForm/publicWaterReport"),
            },
            {
              path: "/index/reconciliation/reportShop/publicPowerRateReport",
              name: "公摊电费报表",
              component: () =>
                import(
                  "@/views/reconciliation/reportShop/publicPowerRateReport"
                ),
            },
            {
              path: "/index/reconciliation/reportShop/powerRateReport",
              name: "商铺电费报表",
              component: () =>
                import(
                  "@/views/reconciliation/reportShop/indoorPowerRateReport"
                ),
            },
            {
              path: "/index/reconciliation/reportShop/waterRateReport",
              name: "商铺水费报表",
              component: () =>
                import("@/views/reconciliation/reportShop/waterRateReport"),
            },
            {
              path: "/index/reconciliation/reportShop/publicWaterReport",
              name: "公摊水费报表",
              component: () =>
                import("@/views/reconciliation/reportShop/publicWaterReport"),
            },
          ],
        },

        {
          //认证
          path: "/index/rz",
          component: () => import("@/views/rz/rz"),
          children: [
            // {
            //   path: "/",
            //   component: () => import("@/views/rz/ykt"),
            // },
            {
              path: "/index/rz/ykt",
              component: () => import("@/views/rz/ykt"),
            },
            {
              path: "/index/rz/sdjn",
              component: () => import("@/views/rz/sdjn"),
            },
            {
              path: "/index/rz/sdjn2",
              name: "水费缴纳",
              component: () => import("@/views/rz/sdjn2"),
            },
            {
              path: "/index/rz/tcyh",
              name: "停车优惠",
              component: () => import("@/views/rz/tcyh"),
            },
            {
              path: "/index/rz/tcgl",
              component: () => import("@/views/rz/tcgl"),
            },
            {
              path: "/index/rz/yktDetail",
              name: "一卡通详情",
              component: () => import("@/views/rz/yktDetail"),
            },
            {
              path: "/index/rz/kpsq",
              name: "开票申请",
              component: () => import("@/views/rz/kpsq"),
            },
            {
              path: "/index/rz/sdjnDetail",
              name: "水电费详情",
              component: () => import("@/views/rz/sdjnDetail"),
            },
            {
              path: "/index/rz/merchantInformation",
              name: "商户信息",
              component: () => import("@/views/rz/merchantInformation"),
            },
            {
              path: "/index/rz/paymentChannel",
              name: "支付渠道",
              component: () => import("@/views/rz/paymentChannel"),
            },
            {
              path: "/index/rz/propertyPayment",
              name: "物业缴纳",
              component: () => import("@/views/rz/propertyPayment"),
            },
            {
              path: "/index/rz/addPropertyPayment",
              name: "物业缴纳详情",
              component: () =>
                import("@/views/rz/component/addPropertyPayment"),
            },
            {
              path: "/index/rz/propertyFeeReport",
              name: "物业费报表",
              component: () => import("@/views/rz/propertyFeeReport"),
            },
            {
              path: "/index/rz/paidFeeReport",
              name: "有偿收费报表",
              component: () => import("@/views/rz/paidFeeReport"),
            },
            {
              path: "/index/rz/publicPowerRateReport",
              name: "公摊电费报表",
              component: () => import("@/views/rz/publicPowerRateReport"),
            },
            {
              path: "/index/rz/indoorPowerRateReport",
              name: "户内电费报表",
              component: () => import("@/views/rz/indoorPowerRateReport"),
            },
            {
              path: "/index/rz/waterRateReport",
              name: "水费报表",
              component: () => import("@/views/rz/waterRateReport"),
            },
            {
              path: "/index/rz/flatsSetting",
              name: "公寓设置",
              component: () => import("@/views/rz/flatsSetting"),
            },
            {
              path: "/index/rz/shopsSetting",
              name: "商铺设置",
              component: () => import("@/views/rz/shopsSetting"),
            },
            {
              path: "/index/rz/faceData",
              name: "人脸数据",
              component: () => import("@/views/rz/faceData"),
            },
            {
              path: "/index/rz/permissionBinding",
              name: "权限绑定",
              component: () => import("@/views/rz/permissionBinding"),
            },
            {
              path: "/index/rz/equipmentManage",
              name: "设备管理",
              component: () => import("@/views/rz/equipmentManage"),
            },
            {
              path: "/index/rz/authenticationManage",
              name: "认证管理",
              component: () => import("@/views/rz/authenticationManage"),
            },
            {
              path: "/index/rz/dataRecord/paymentRecord",
              name: "支付记录",
              component: () => import("@/views/rz/dataRecord/paymentRecord"),
            },
          ],
        },
        {
          //安防-设置
          path: "/index/safeSetting",
          component: () => import("@/views/safeSetting/safeSetting"),
          children: [
            {
              path: "/",
              component: () => import("@/views/safeSetting/placeManage"),
            },
            {
              path: "/index/safeSetting/placeManage",
              name: "场所管理",
              component: () => import("@/views/safeSetting/placeManage"),
            },
            {
              path: "/index/safeSetting/areaManage",
              name: "区域管理",
              component: () => import("@/views/safeSetting/areaManage"),
            },

            {
              path: "/index/safeSetting/cameraManage",
              name: "相机管理",
              component: () => import("@/views/safeSetting/cameraManage"),
            },
            {
              path: "/index/safeSetting/eventTypeManage",
              name: "事件类型",
              component: () => import("@/views/safeSetting/eventTypeManage"),
            },
            {
              path: "/index/safeSetting/workTime",
              name: "班次信息",
              component: () => import("@/views/safeSetting/workTime"),
            }
          ],
        },

        {
          //保洁部
          path: "/index/cleaning",
          component: () => import("@/views/cleaning/index"),
          children: [
            {
              path: "/index/cleaning/rosteringPlan",
              name: "计划管理",
              component: () => import("@/views/cleaning/rosteringPlan"),
            },
            {
              path: "/index/cleaning/eventDetection",
              name: "事件检测",
              component: () => import("@/views/cleaning/eventDetection"),
            },
            {
              path: "/index/cleaning/outConfirmation",
              name: "退房确认",
              component: () => import("@/views/cleaning/outConfirmation"),
            },
            {
              path: "/index/cleaning/paidService",
              name: "有偿服务",
              component: () => import("@/views/cleaning/paidService"),
            },
          ],
        },

        {
          //工程
          path: "/index/engineering",
          component: () => import("@/views/engineering/index"),
          children: [
            {
              path: "/index/engineering/rosteringPlan",
              name: "计划管理",
              component: () => import("@/views/engineering/rosteringPlan"),
            },
            {
              path: "/index/engineering/dutyRecord",
              name: "值班记录",
              component: () => import("@/views/engineering/dutyRecord"),
            },
            {
              path: "/index/engineering/repair/apartmentRepair",
              name: "公寓报修",
              component: () => import("@/views/apartment/repair"),
            },
            {
              path: "/index/engineering/repair/repairPublic",
              name: "公区报修",
              component: () => import("@/views/engineering/repair/repairPublic"),
            },
            {
              path: "/index/engineering/repair/record",
              name: "报修记录",
              component: () => import("@/views/engineering/repair/record"),
            },
            {
              path: "/index/engineering/repair/dispatch",
              name: "派工管理",
              component: () => import("@/views/engineering/repair/dispatch"),
            },
            {
              path: "/index/engineering/repair/complaint",
              name: "维修投诉",
              component: () => import("@/views/engineering/repair/complaint"),
            },
         
            {
              path: "/index/engineering/energyManage/shophHdropower",
              name: "商业水电",
              component: () => import("@/views/business/storeInformation"),
            },
            {
              path: "/index/engineering/energyManage/energyData",
              name: "能耗数据",
              component: () =>
                import("@/views/engineering/energyManage/energyData"),
            },
            {
              path: "/index/engineering/energyManage/energyReport",
              name: "能耗报表",
              component: () =>
                import("@/views/engineering/energyManage/energyReport"),
            },
            {
              path: "/index/engineering/energyManage/BAData",
              name: "BA数据",
              component: () =>
                import("@/views/engineering/energyManage/BAData"),
            },
            {
              path: "/index/engineering/energyManage/publicElectric",
              name: "公区电表",
              component: () =>
                import("@/views/engineering/energyManage/publicElectric"),
            },
               {
              path: "/index/engineering/energyManage/electricData",
              name: "电表数据",
              component: () =>
                import("@/views/engineering/energyManage/electricData"),
            },
               {
              path: "/index/engineering/energyManage/waterData",
              name: "水表数据",
              component: () =>
                import("@/views/engineering/energyManage/waterData"),
            },
               {
              path: "/index/engineering/equipmentSafety/equipmentSafety",
              name: "设备安全",
              component: () =>
                import("@/views/engineering/equipmentSafety/equipmentSafety"),
            },
            {
              path: "/index/engineering/decorationManagement",
              name: "装修管理",
              component: () =>
                import("@/views/engineering/decorationManagement"),
            },
          ],
        },
        {
          //停车
          path: "/index/stopCar",
          component: () => import("@/views/stopCar/index"),
          children: [
               {
              path: "/index/stopCar/parkingManage",
              name: "停车管理",
              component: () =>
                import(
                  "@/views/stopCar/parkingManage"
                ),
            },
            {
              path: "/index/stopCar/record",
              name: "停车记录",
              component: () => import("@/views/stopCar/record"),
            },
            {
              path: "/index/stopCar/parkingConcessions",
              name: "停车优惠",
              component: () =>
                import(
                  "@/views/stopCar/parkingConcessions"
                ),
            },
            {
              path: "/index/stopCar/report",
              name: "停车表报",
              component: () =>
                import(
                  "@/views/stopCar/report"
                ),
            },
            {
              path: "/index/stopCar/classificationSummary",
              name: "停车分类汇总",
              component: () =>
                import(
                  "@/views/stopCar/classificationSummary"
                ),
            },
         
            // {
            //   path: "/index/engineering/paidService",
            //   name: "有偿服务",
            //   component: () => import("@/views/engineering/paidService"),
            // },
          ],
        },
      ],
    },
  ],
});

export default router;
